export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const PRIVACY_POLICY_URL = 'https://www.jellyvision.com/privacy/';
export const YOUR_PRIVACY_CHOICES_URL = 'https://www.jellyvision.com/privacy-choices';
export const TERMS_OF_SERVICE = 'https://www.jellyvision.com/tos/';
export const MY_ALEX_HEALTH_URL = 'https://www.myalexhealth.com/';
export const ALEX_MEDICARE_B2B_BASE_URL = 'https://medicare.myalex.com';

// Where the customer sends employees for Medicare help. Chosen in ALEX Builder.
export enum MedicareDestination {
  MY_ALEX_HEALTH = 'my-alex-health',
  ALEX_MEDICARE_EDUCATION = 'alex-medicare-education',
  NO_CALL_OUTS = 'no-call-outs',
}
// Used when the customer has not chosen, or the choice cannot be read.
export const DEFAULT_MEDICARE_DESTINATION = MedicareDestination.ALEX_MEDICARE_EDUCATION;

export enum PREMIUM_PERIOD {
  MONTHLY = 'Monthly',
}

export enum DEPLOY_ENVIRONMENTS {
  DEV = 'dev',
  MR_REVIEW = 'review',
  STAGING = 'staging',
  UAT = 'uat',
  PROD = 'prod',
}

// Array of errors we do not want sentry to send us alerts for.
// The values themselves are partial string matches for the exception listed
// last in the breadcrumbs.
// Also allows regex for exact matches.
export const SENTRY_IGNORE = [
  'getBoundingClientRect',
  'Non-Error promise rejection captured with value: Object Not Found Matching Id',
  'Request aborted',
  'No valid configurations found',
  'Failed to fetch',
  'Load failed',
];
